<div class="campaign-dashboard">
  <div class="revenue-dashboard-header">
    <div class="header-left">
      <div class="title-section">
        <div class="title-row">
          <h2 class="revenue-title">Campaign Management</h2>
        </div>
        <p class="revenue-description">Track and optimize your marketing campaigns.</p>
      </div>
    </div>
    <div class="header-right">
      <div class="dropdown-container">
        <button
          class="today-dropdown"
          (click)="toggleLocationDropdown.emit(); $event.stopPropagation()"
        >
          <span>{{ selectedLocationLabel || 'All Locations' }}</span>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            [class.rotated]="isLocationDropdownOpen"
          >
            <path
              d="M5.28 7.38L10 12.1L14.72 7.38"
              stroke="#15172E"
              stroke-width="1"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <div
          class="dropdown-menu"
          *ngIf="isLocationDropdownOpen"
          (click)="$event.stopPropagation()"
        >
          <div class="dropdown-header">
            <span class="dropdown-title">Location</span>
          </div>
          <div class="dropdown-options">
            <div
              class="radio-option"
              *ngFor="let option of locationOptions; trackBy: trackByValue"
              (click)="selectLocation.emit(option.value)"
            >
              <div class="radio-button" [class.selected]="selectedLocation === option.value">
                <div class="radio-inner" *ngIf="selectedLocation === option.value"></div>
              </div>
              <span class="radio-label" [class.selected]="selectedLocation === option.value">{{
                option.label
              }}</span>
            </div>
            <div class="radio-option" *ngIf="!locationOptions?.length">
              <div class="radio-button selected">
                <div class="radio-inner"></div>
              </div>
              <span class="radio-label selected">No Location</span>
            </div>
          </div>
        </div>
      </div>

      <div class="dropdown-container period-dropdown-wrapper">
        <button
          class="today-dropdown"
          (click)="toggleCampaignDropdown.emit(); $event.stopPropagation()"
        >
          <span>{{ selectedPeriodLabel || selectedCampaignPeriod }}</span>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            [class.rotated]="isCampaignDropdownOpen"
          >
            <path
              d="M5.28 7.38L10 12.1L14.72 7.38"
              stroke="#15172E"
              stroke-width="1"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        <app-date-range-picker
          [isOpen]="isCampaignDropdownOpen"
          [selectedPeriod]="selectedCampaignPeriod"
          [customDateRange]="customDateRange"
          [periodOptions]="periodOptions"
          (close)="closePeriodDropdown.emit()"
          (apply)="dateRangeApply.emit($event)"
        >
        </app-date-range-picker>
      </div>
    </div>
  </div>

  <div class="dashboard-content">
    <div class="campaign-stats-container">
      <div class="campaign-stats-grid">
        <app-customer-stats-card
          *ngFor="let stat of campaignDashboardStats; trackBy: trackByStatTitle"
          [data]="stat"
        >
        </app-customer-stats-card>
      </div>
    </div>

    <div class="campaign-filter-section">
      <div class="campaign-filter-header">
        <div class="filter-title-section">
          <h3 class="filter-title">Overall Campaign Statistics</h3>
        </div>
        <div class="campaign-filter-controls">
          <div class="campaign-filter-row">
            <div class="dropdown-container">
              <button
                class="filter-dropdown"
                (click)="toggleCampaignNameDropdown.emit(); $event.stopPropagation()"
              >
                <span>{{ displayCampaignName }}</span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  [class.rotated]="isCampaignNameDropdownOpen"
                >
                  <path
                    d="M5.28 7.38L10 12.1L14.72 7.38"
                    stroke="#15172E"
                    stroke-width="1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>

              <div
                class="dropdown-menu"
                *ngIf="isCampaignNameDropdownOpen"
                (click)="$event.stopPropagation()"
              >
                <div class="dropdown-header">
                  <span class="dropdown-title">Campaign Name</span>
                </div>
                <div class="dropdown-options">
                  <div
                    class="radio-option"
                    *ngFor="let option of campaignNameOptions; trackBy: trackByValue"
                    (click)="selectCampaignName.emit(option.value)"
                  >
                    <div
                      class="radio-button"
                      [class.selected]="selectedCampaignName === option.value"
                    >
                      <div class="radio-inner" *ngIf="selectedCampaignName === option.value"></div>
                    </div>
                    <span
                      class="radio-label"
                      [class.selected]="selectedCampaignName === option.value"
                      >{{ option.label }}</span
                    >
                  </div>
                  <div class="radio-option" *ngIf="!campaignNameOptions?.length">
                    <div class="radio-button">
                      <div class="radio-inner"></div>
                    </div>
                    <span class="radio-label">No Campaigns Available</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="dropdown-container" *ngIf="selectedCampaignName">
              <button
                class="filter-dropdown"
                (click)="toggleCampaignTypeDropdown.emit(); $event.stopPropagation()"
              >
                <span>{{ selectedCampaignType }}</span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  [class.rotated]="isCampaignTypeDropdownOpen"
                >
                  <path
                    d="M5.28 7.38L10 12.1L14.72 7.38"
                    stroke="#15172E"
                    stroke-width="1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>

              <div
                class="dropdown-menu"
                *ngIf="isCampaignTypeDropdownOpen"
                (click)="$event.stopPropagation()"
              >
                <div class="dropdown-header">
                  <span class="dropdown-title">Campaign Type</span>
                </div>
                <div class="dropdown-options">
                  <div
                    class="radio-option"
                    *ngFor="let option of campaignTypeOptions; trackBy: trackByValue"
                    (click)="selectCampaignType.emit(option.label)"
                  >
                    <div
                      class="radio-button"
                      [class.selected]="selectedCampaignType === option.label"
                    >
                      <div class="radio-inner" *ngIf="selectedCampaignType === option.label"></div>
                    </div>
                    <span
                      class="radio-label"
                      [class.selected]="selectedCampaignType === option.label"
                      >{{ option.label }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="campaign-bottom-stats">
        <div class="campaign-bottom-stats-grid">
          <app-campaign-bottom-card
            *ngFor="let stat of campaignBottomStats; trackBy: trackByStatTitle"
            [data]="stat"
          >
          </app-campaign-bottom-card>
        </div>
      </div>
    </div>
    <!-- Figma Empty State - Show when page loads and all data is empty -->
    <div *ngIf="shouldShowEmptyState()" class="empty-state-container">
      <div class="empty-state-content">
        <div class="empty-state-illustration">
          <img src="assets/images/empty-state-illustration.svg" alt="No data illustration" />
        </div>
        <div class="empty-state-text">
          <h3 class="empty-state-title">Nothing to show!</h3>
          <p class="empty-state-description">There is no campaign data to display.</p>
        </div>
      </div>
    </div>
    <div class="campaign-charts-section">
      <div class="campaign-charts-row">
        <div class="campaign-trend-chart-card" *ngIf="!shouldShowEmptyState()">
          <div class="card-header">
            <div class="header-content">
              <h3 class="card-title">Campaign Performance Trend</h3>
              <div
                class="info-icon"
                [matTooltip]="'Trend showing how the campaign performance changes over time.'"
                tabindex="0"
                matTooltipPosition="above"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 0C3.134 0 0 3.134 0 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm0 12.833c-3.225 0-5.833-2.608-5.833-5.833S3.775 1.167 7 1.167 12.833 3.775 12.833 7 10.225 12.833 7 12.833z"
                    fill="#15172E"
                  />
                  <path
                    d="M7 3.5c-.483 0-.875.392-.875.875S6.517 5.25 7 5.25s.875-.392.875-.875S7.483 3.5 7 3.5zM7 6.125c-.483 0-.875.392-.875.875v2.625c0 .483.392.875.875.875s.875-.392.875-.875V7c0-.483-.392-.875-.875-.875z"
                    fill="#15172E"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div *ngIf="!isCampaignPerformanceTrendDataEmpty()" class="campaign-trend-chart-wrapper">
            <canvas
              baseChart
              type="line"
              [data]="campaignPerformanceTrendData"
              [options]="campaignPerformanceTrendOptions"
              class="campaign-trend-chart"
            >
            </canvas>
          </div>

          <!-- Show empty state when no data or all data is zero -->
          <div *ngIf="isCampaignPerformanceTrendDataEmpty()" class="no-data-message">
            <p class="p5">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.00032 5.9998V8.66647M8.00032 10.6665H8.00698M6.90898 2.3938L1.50498 11.4165C1.39358 11.6094 1.33463 11.8281 1.33399 12.0509C1.33335 12.2737 1.39105 12.4927 1.50135 12.6863C1.61164 12.8798 1.77069 13.0412 1.96268 13.1542C2.15466 13.2672 2.37289 13.328 2.59565 13.3305H13.405C13.6276 13.3279 13.8458 13.2671 14.0377 13.1541C14.2295 13.0411 14.3885 12.8799 14.4988 12.6865C14.6091 12.493 14.6668 12.2741 14.6663 12.0514C14.6657 11.8287 14.6069 11.61 14.4956 11.4171L9.09165 2.39313C8.97795 2.20547 8.81778 2.0503 8.62662 1.9426C8.43545 1.8349 8.21973 1.77832 8.00032 1.77832C7.7809 1.77832 7.56519 1.8349 7.37402 1.9426C7.18285 2.0503 7.02268 2.20547 6.90898 2.39313V2.3938Z"
                  stroke="#717683"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              No data available for the selected period.
            </p>
          </div>
        </div>

        <div class="campaign-funnel-chart-card" *ngIf="!shouldShowEmptyState()">
          <div class="card-header">
            <div class="header-content">
              <h3 class="card-title">Campaign Funnel</h3>
              <div
                class="info-icon"
                [matTooltip]="'Breakdown of campaign performance for each marketing type.'"
                tabindex="0"
                matTooltipPosition="above"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 0C3.134 0 0 3.134 0 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm0 12.833c-3.225 0-5.833-2.608-5.833-5.833S3.775 1.167 7 1.167 12.833 3.775 12.833 7 10.225 12.833 7 12.833z"
                    fill="#15172E"
                  />
                  <path
                    d="M7 3.5c-.483 0-.875.392-.875.875S6.517 5.25 7 5.25s.875-.392.875-.875S7.483 3.5 7 3.5zM7 6.125c-.483 0-.875.392-.875.875v2.625c0 .483.392.875.875.875s.875-.392.875-.875V7c0-.483-.392-.875-.875-.875z"
                    fill="#15172E"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="campaign-funnel-content">
            <!-- <div class="funnel-metrics">
            <div class="funnel-metric-item">
              <div class="metric-label">Type of Campaign</div>
              <div class="metric-value">Email</div>
            </div>
            <div class="funnel-metric-item">
              <div class="metric-label">Open Rate</div>
              <div class="metric-value">44%</div>
            </div>
            <div class="funnel-metric-item">
              <div class="metric-label">Overall Conversion</div>
              <div class="metric-value conversion-rate">8%</div>
            </div>
          </div> -->

            <div *ngIf="!isCampaignFunnelDataEmpty()" class="funnel-chart-wrapper">
              <canvas
                baseChart
                type="line"
                [data]="campaignFunnelData"
                [options]="campaignFunnelOptions"
                class="campaign-funnel-chart"
              >
              </canvas>
            </div>

            <!-- Show empty state when no data or all data is zero -->
            <div *ngIf="isCampaignFunnelDataEmpty()" class="no-data-message">
              <p class="p5">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00032 5.9998V8.66647M8.00032 10.6665H8.00698M6.90898 2.3938L1.50498 11.4165C1.39358 11.6094 1.33463 11.8281 1.33399 12.0509C1.33335 12.2737 1.39105 12.4927 1.50135 12.6863C1.61164 12.8798 1.77069 13.0412 1.96268 13.1542C2.15466 13.2672 2.37289 13.328 2.59565 13.3305H13.405C13.6276 13.3279 13.8458 13.2671 14.0377 13.1541C14.2295 13.0411 14.3885 12.8799 14.4988 12.6865C14.6091 12.493 14.6668 12.2741 14.6663 12.0514C14.6657 11.8287 14.6069 11.61 14.4956 11.4171L9.09165 2.39313C8.97795 2.20547 8.81778 2.0503 8.62662 1.9426C8.43545 1.8349 8.21973 1.77832 8.00032 1.77832C7.7809 1.77832 7.56519 1.8349 7.37402 1.9426C7.18285 2.0503 7.02268 2.20547 6.90898 2.39313V2.3938Z"
                    stroke="#717683"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                No data available for the selected period.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
